import { Campground, Folder, autofillData_cachedForm } from "./type_defs";
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { APPLICATIONINSIGHTS_CONNECTION_STRING, G_MAPS_CLIENT_API_KEY, LD_CLIENT_KEY} from '../config';
import { Campground_Data, POI_Data, Trip_Filters_cachedForm, Trip_cookieFormat_v2, Trip_legCachedFormat_v2, Trip_v2, trip_clusterCachedFormat } from "./tripPlanner_types";
import * as LDClient from 'launchdarkly-js-client-sdk';

import * as crypto from 'crypto-browserify';


export async function places_search(query:string,location_bias:{latitude:number,longitude:number}|null):Promise<any> {
	// return new Promise<any>((resolve,reject) => {
	// 	$.ajax({
	// 		url: `https://maps.google.apis.com/maps/api/place/textsearch/json?query=${query}&key=${G_MAPS_CLIENT_API_KEY}`,
	// 		type: 'get',
	// 		success: (data) => {resolve(data);},
	// 		error: (xhr, errMsg, exc) => {reject(new Error(errMsg));}
	// 	});
	// });
	const bodyJSON:{textQuery:string,locationBias?:any} = {
		textQuery: query
	};
	if (location_bias != null) {
		bodyJSON.locationBias = {
			circle: {
				center: location_bias,
				radius: 10000
			}
		}
	}
	return new Promise<any>((resolve,reject) => {
		fetch("https://places.googleapis.com/v1/places:searchText",
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					"X-Goog-Api-Key": G_MAPS_CLIENT_API_KEY,
					'X-Goog-FieldMask': 'places.displayName,places.googleMapsUri,places.websiteUri'
				},
				body: JSON.stringify(bodyJSON)
			}
		).then(response => {
			resolve(response.json());
		}).catch(e => {
			console.error(e);
		});
	});
};

export function hide_tooltips() {
	document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(tooltipTriggerEl => {
		let tooltipInstance = window.bootstrap.Tooltip.getInstance(tooltipTriggerEl);
		if (tooltipInstance) {
		   tooltipInstance.hide();
		}
	 });
};

export function get_date_ignoreTimezone(date:Date|string|undefined) {
	if (date == undefined) return undefined;
	let dateStr:string;
	let dateComponents:Array<string>;
	if (typeof date == "string") {
		const dateStrMatch = date.match(/\d{4}-\d{2}-\d{2}/)
		if (dateStrMatch != undefined) {
			dateStr = dateStrMatch[0];
			dateComponents = dateStr.split("-");
		} else {
			try {
				const d = new Date(date);
				dateComponents = [
					d.getFullYear().toString(),
					(d.getMonth() + 1).toString(),
					d.getDate().toString()
				]
			} catch {
				return null;
			};
		};

	} else {
		dateComponents = [
			date.getFullYear().toString(),
			(date.getMonth() + 1).toString(),
			date.getDate().toString()
		];
	};


	let d:Date = new Date();
	d.setFullYear(parseInt(dateComponents[0]));
	d.setMonth(parseInt(dateComponents[1]) - 1);
	d.setDate(parseInt(dateComponents[2]));
	d.setHours(0);
	d.setMinutes(0);
	d.setSeconds(0);
	d.setMilliseconds(0);

	return d;
};

export async function initCardedTrialArtifact() {
	if (window.featureFlags == undefined ) {
		await getAllFeatureFlags();
	};
	let d:Date = new Date();
	let trialLen:number = window.featureFlags.trialPeriod_days;
	d.setDate(d.getDate() + trialLen);
	let dateStr:string =  d.toLocaleDateString("en-US", {
		month: "short",
		day: "numeric",
		// year: "numeric"
	});
	document.querySelectorAll("[trialTimelineSubStartDate]").forEach((el) => {
		el.innerHTML = dateStr;
	});
	d = new Date();
	d.setDate(d.getDate() + trialLen - 7);
	dateStr =  d.toLocaleDateString("en-US", {
		month: "short",
		day: "numeric",
		// year: "numeric"
	});
	document.querySelectorAll("[trialTimelineNotifDate]").forEach((el) => {
		el.innerHTML = dateStr;
	});
};


export function init_popovers(parentEl:JQuery<HTMLElement>) {
	parentEl.find('[data-bs-toggle="popover"]').each(function(index,elem) {
		try {
			let content = $(elem).attr("data-bs-content");
			if (content === null || content === undefined) content = "";
			const popover = new window.bootstrap.Popover(elem, {
				placement: $(elem).attr("data-bs-placement"),
				content: content,
				container: $(elem).attr("data-bs-container")
			});
		} catch {
		};
	});
};

const emailRegex:RegExp = /^[\w-\.+]+@([\w-]+\.)+[\w-]{2,4}$/
export const checkEmailValid = (email:string) => {
	return emailRegex.test(email);
};

import {Loader} from "@googlemaps/js-api-loader";
let googleMapsPromise: Promise<typeof google.maps> | null = null;
let isInitializing: boolean = false;

export async function getGoogleMaps(): Promise<typeof google.maps> {
	if (window.google != undefined && window.google.maps != undefined) {
		return Promise.resolve(window.google.maps);
	};
	while (isInitializing) {
        await new Promise(resolve => setTimeout(resolve, 10));
    }
	if (!googleMapsPromise) {
		isInitializing = true;
		const loader = new Loader({
			apiKey: G_MAPS_CLIENT_API_KEY,
			version: "weekly",
		});
		googleMapsPromise = loader.load().then(() => {
            isInitializing = false; // Unlock
            return google.maps;
        }).catch((error:Error) => {
            isInitializing = false; // Unlock on error too
            throw error;
        });
	}
  return googleMapsPromise;
};

export const featureFlagKeys = [
	"tripPlanner-magicSearch",
	"preferencesNumOptions",
	"s2n_v1",
	"bannerSale",
	"freemiumAccess",
	"trialPeriod_days",
	"freeTrialState",
	"mapTileProvider",
	"walmartOnRoute",
	"post-signup-offer"
];


export function getHash(data: string) {
	const hash = crypto.createHash('sha1');
	hash.update(data);
	return hash.digest('hex');
};

/*
 * input: trip in Trip_v2 format (see general_util/tripPlanner_types.ts)
 * output: trip in cookie format (see general_util/tripPlanner_types.ts)
 */
export function getTrip_cachedForm(trip:Trip_v2):Trip_cookieFormat_v2 {
	let tripCookie:Trip_cookieFormat_v2;

	let legs:Array<Trip_legCachedFormat_v2> = [];
	for(let i:number=0; i < trip.legs.length; i++) {
		let leg:Trip_legCachedFormat_v2 = {
			l: trip.legs[i].lockedStops,
			c: []
		}
		for (let j:number=0; j < trip.legs[i].clusters.length; j++) {
			let clusterStops_stays: Array<{
				i:number,//campID
				sd?:Date,//s_date
				n?:number//numNights
			}> = [];
			for (let k:number=0; k < trip.legs[i].clusters[j].selectedCamps.length; k++) {
				let stay:{
					i:number,//campID
					sd?:Date,//s_date
					n?:number//numNights
					f?:boolean//is_fake_camp
					cn?:string//custom_name
					dl?:boolean//datesLocked
					r_id?:number|string//reservationId
				} = {
					i: trip.legs[i].clusters[j].selectedCamps[k].camp.campID
				};
				if ("s_date" in trip.legs[i].clusters[j].selectedCamps[k] && "numNights" in trip.legs[i].clusters[j].selectedCamps[k]) {
					if (trip.legs[i].clusters[j].selectedCamps[k].numNights != null) {
						stay.sd = trip.legs[i].clusters[j].selectedCamps[k].s_date;
						stay.n = trip.legs[i].clusters[j].selectedCamps[k].numNights;
					};
				};

				if ("is_fake_camp" in trip.legs[i].clusters[j].selectedCamps[k]) {
					stay.f = true;
					stay.cn = trip.legs[i].clusters[j].selectedCamps[k].camp.camp_name;
				}

				if ("datesLocked" in trip.legs[i].clusters[j].selectedCamps[k]) {
					stay.dl = trip.legs[i].clusters[j].selectedCamps[k].datesLocked;
				};
				if ("reservationId" in trip.legs[i].clusters[j].selectedCamps[k]) {
					stay.r_id = trip.legs[i].clusters[j].selectedCamps[k].reservationId;
				}

				clusterStops_stays.push(stay);
			};
			let cluster_POIs:Array<{id:string,d?:Date}> = [];
			if (trip.legs[i].clusters[j].POIs !== undefined) {
				for (let k:number = 0; k < trip.legs[i].clusters[j].POIs.length; k++) {
					let poi:{id:string,d?:Date} = {id:trip.legs[i].clusters[j].POIs[k].id};

					if ("date" in trip.legs[i].clusters[j].POIs[k]) {
						poi.d = trip.legs[i].clusters[j].POIs[k].date;
					};
					cluster_POIs.push(poi);
				};
			};
			let cluster:trip_clusterCachedFormat = {
				c: [trip.legs[i].clusters[j].coords.longitude, trip.legs[i].clusters[j].coords.latitude],
				s: clusterStops_stays,
				p: cluster_POIs,
				u: trip.legs[i].clusters[j].fromUserQuery? 1: 0,
				t: trip.legs[i].clusters[j].clusterTitle,
				id: trip.legs[i].clusters[j].stopID
			};
			if (trip.legs[i].clusters[j].notes !== undefined) {
				cluster.no = trip.legs[i].clusters[j].notes;
			};
			if (trip.legs[i].clusters[j].radius != null && trip.legs[i].clusters[j].radius != undefined) {
				cluster.r = trip.legs[i].clusters[j].radius
			};
			if (trip.legs[i].clusters[j].hideStopPin != undefined) {
				cluster.hp = trip.legs[i].clusters[j].hideStopPin;
			};
			if (trip.legs[i].clusters[j].wishes != undefined) {
				cluster.w = trip.legs[i].clusters[j].wishes;
			};

			if ("s_date" in trip.legs[i].clusters[j] && "numNights" in trip.legs[i].clusters[j]) {
				cluster.sd = trip.legs[i].clusters[j].s_date;
				cluster.n = trip.legs[i].clusters[j].numNights;
			};

			leg.c.push(cluster)
		};
		legs.push(leg);
	};

	let cachedForm_filters:Trip_Filters_cachedForm = {
		d: trip.filters.driveTime,
		D: trip.filters.driveDist,
		r: trip.filters.routeWidth,
		a: trip.filters.avoidHighways,
		to: trip.filters.avoidTolls,
		f: trip.filters.avoidFerries,
		tu: trip.filters.avoidTunnels,
		ufd: trip.filters.useFullDriveDist,
		vt: trip.filters.vehicleType,
		aA: trip.filters.avoidAreas,
		aS: trip.filters.avoidStates,
		du: trip.filters.dist_unit
	};

	let cachedForm_autofill:Array<autofillData_cachedForm> = [];
	for (let i:number = 0; i < trip.autoFillData.length; i++) {
		cachedForm_autofill.push({
			t: trip.autoFillData[i].query_type,
			v: trip.autoFillData[i].query_val
		})
	};

	tripCookie = {
		q: trip.queries,
		f: cachedForm_filters,
		a: cachedForm_autofill,
		s: trip.startDate,
		lL: trip.lockedLegs,
		n: trip.name,
		d: trip.desc,
		tripID: trip.tripID,
		l:legs
	};
	if (trip.geo_queries) tripCookie.g_q= trip.geo_queries;
	if (trip.itinerary) tripCookie.it = trip.itinerary;
	if (trip.searchQuery) tripCookie.sq = trip.searchQuery;

	return tripCookie;
};

/*
 * input: time string in format '00:00'
 * output: number minutes
 */
export function check_driveTimeStr_getNum(driveTime_str:string):number {
	let driveTime_arr:Array<string> | null;
	if (!driveTime_str.match(/^(?:[01]\d|2[0-3]):[0-5]\d/)) return 0;
	driveTime_arr = driveTime_str.split(":");
	if (driveTime_arr && driveTime_arr.length) return ((parseInt(driveTime_arr[0]) * 60) + parseInt(driveTime_arr[1]));
};

export function formatPlannedTrip(rawText: string) {
	let text = rawText.split('Day');
	let formattedText = '';
	for (let i = 1; i < text.length; i++) {
			formattedText += '<p><strong style="font-weight:700;">Day' + text[i] + '</strong></p>';
	}
	formattedText = formattedText.replace(/- /g, '<br/>- ');
	return formattedText;
}

export function extract_tripData_forHTML(trip:Trip_v2) {
	let forHTML_legs:Array<{
		lockedStops:Array<number>,
		clusters:Array<{
			selectedCamps:Array<Campground_Data>,
			fromUserQuery:boolean,
			clusterTitle:string,
			coords:{latitude:number,longitude:number},
			notes?:any,
			POIs: Array<POI_Data>
		}>}> = [];

	for(let i:number=0; i < trip.legs.length; i++) {
		let forHTML_leg:{
			lockedStops:Array<number>,
			clusters:Array<{
				selectedCamps:Array<Campground_Data>,
				fromUserQuery:boolean,
				clusterTitle:string,
				coords:{latitude:number,longitude:number},
				notes?:any,
				POIs: Array<POI_Data>
		}>} = {
			lockedStops: trip.legs[i].lockedStops,
			clusters: [],
		};

		for (let j:number=0; j < trip.legs[i].clusters.length; j++) {
			let stays:Array<Campground_Data> = trip.legs[i].clusters[j].selectedCamps;

			let cluster:any = {
				selectedCamps: stays,
				fromUserQuery: trip.legs[i].clusters[j].fromUserQuery,
				clusterTitle: trip.legs[i].clusters[j].clusterTitle,
				coords: trip.legs[i].clusters[j].coords,
				POIs: trip.legs[i].clusters[j].POIs
			};

			if (trip.legs[i].clusters[j].notes !== undefined) {
				cluster.notes = trip.legs[i].clusters[j].notes;
			}

			forHTML_leg.clusters.push(cluster);
		};
		forHTML_legs.push(forHTML_leg);
	};

	return forHTML_legs;
}

export function initCookieChoice() {
	let cookieChoice:string = getCookie_base64("cookieChoice");
	if (cookieChoice == "") {
		/* cookie choice not set */
		$("#anonUserCookiePopup").show()
		// window.appInsights = null;
	}
	else if (cookieChoice == "1") {
		/* cookie choice: Necessary only */
		// window.appInsights = null;
		// window.appInsights = null;
		$("#anonUserCookiePopup").hide();
	} else if (cookieChoice == "2") {
		/* cookie choice: All */
		$("#anonUserCookiePopup").hide();
	};
	window.appInsights = new ApplicationInsights({ config: {
		connectionString: APPLICATIONINSIGHTS_CONNECTION_STRING
	}});
	window.appInsights.loadAppInsights();
	window.appInsights.trackPageView();

	let clarityScript:HTMLScriptElement = document.createElement("script");
	clarityScript.type = "text/javascript";
	clarityScript.innerHTML = `
	if (!window.location.host.includes('localhost')) {
		(function(c,l,a,r,i,t,y){
		c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
		t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
		y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
		})(window, document, "clarity", "script", "emyk1zblbs");
	};
	`;

	let googleTagManagerScript:HTMLScriptElement = document.createElement("script");
	googleTagManagerScript.type = "text/javascript";
	if (!window.location.host.includes('localhost') && !window.location.host.includes('testing') && !window.location.host.includes('staging')) {
		googleTagManagerScript.innerHTML = `
		(function(w,d,s,l,i){
			w[l]=w[l]||[];
			w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
			var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
			j.async=true;
			j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl+ '&gtm_auth=iovQOE7jAeijkKNlXMxC-Q&gtm_preview=env-1&gtm_cookies_win=x';
			f.parentNode.insertBefore(j,f);
		})(window,document,'script','dataLayer','GTM-58QQTZ9');
		`;
	} else {
		googleTagManagerScript.innerHTML = `
		(function(w,d,s,l,i){
			w[l]=w[l]||[];
			w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
			var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
			j.async=true;
			j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl+ '&gtm_auth=6TkLikOKhuxkxc_c2AsIeA&gtm_preview=env-57&gtm_cookies_win=x';
			f.parentNode.insertBefore(j,f);
		})(window,document,'script','dataLayer','GTM-58QQTZ9');
		`;
	};

	let tagManager_noScript:HTMLElement = document.createElement("noscript");
	if (!window.location.host.includes('localhost') && !window.location.host.includes('testing') && !window.location.host.includes('staging')) {
		tagManager_noScript.innerHTML = `
		<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-58QQTZ9&gtm_auth=iovQOE7jAeijkKNlXMxC-Q&gtm_preview=env-1&gtm_cookies_win=x"
	height="0" width="0" style="display:none;visibility:hidden"></iframe>
	`;
	} else {
		tagManager_noScript.innerHTML = `
		<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-58QQTZ9&gtm_auth=6TkLikOKhuxkxc_c2AsIeA&gtm_preview=env-57&gtm_cookies_win=x"
height="0" width="0" style="display:none;visibility:hidden"></iframe>
		`;
	};



	let googleTag_gtagjs:HTMLScriptElement = document.createElement("script");
	googleTag_gtagjs.setAttribute("async", "");
	if (!window.location.host.includes('localhost') && !window.location.host.includes('testing') && !window.location.host.includes('staging')) {
		//production environment
		googleTag_gtagjs.setAttribute("src", "https://www.googletagmanager.com/gtag/js?id=G-PJ6RZ9TT0W");
		googleTag_gtagjs.type = "text/javascript";
		googleTag_gtagjs.innerHTML = `
		window.dataLayer = window.dataLayer || [];
		function gtag(){dataLayer.push(arguments);}
		gtag('js', new Date());
		gtag('config', 'G-PJ6RZ9TT0W');
		`;
	} else {
		//testing analytics environment
		googleTag_gtagjs.setAttribute("src", "https://www.googletagmanager.com/gtag/js?id=G-HF1V786093");
		googleTag_gtagjs.type = "text/javascript";
		googleTag_gtagjs.innerHTML = `
		window.dataLayer = window.dataLayer || [];
		function gtag(){dataLayer.push(arguments);}
		gtag('js', new Date());
		gtag('config', 'G-HF1V786093');
		`;
	};

	document.body.appendChild(tagManager_noScript);
	document.head.appendChild(googleTagManagerScript);
	document.head.appendChild(googleTag_gtagjs);
	if (!window.location.host.includes('localhost') && !window.location.host.includes('testing') && !window.location.host.includes('staging')) {
		document.head.appendChild(clarityScript);
	};
};

const MI_PER_KM:number = 0.6213712;

const hasSpecialChar:RegExp = /[ !@#$^&*()_+\-=\[\]{};:\\|,.<>\/?~%]/;
const hasNumber:RegExp = /\d/;
const hasUppercase:RegExp = /[A-Z]/;
const hasLowerCase:RegExp = /[a-z]/;

const place_types = [
    "amusement_park",
    "aquarium",
    "art_gallery",
    "bar",
    "bowling_alley",
    "cafe",
    "casino",
    "gas_station",
    "laundry",
    "liquor_store",
    "movie_theater",
    "museum",
    "park",
    "pet_store",
    "restaurant",
    "shopping_mall",
    "stadium",
    "supermarket",
    "tourist_attraction",
    "zoo"
];

export function initializeTooltips() {
	var tooltipTriggerList:any = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
	var tooltipList:any = tooltipTriggerList.map(function (tooltipTriggerEl:any) {
		return new window.bootstrap.Tooltip(tooltipTriggerEl);
	});
};

export const sleep = async (ms:number) => {
	return new Promise(resolve => setTimeout(resolve,ms));
};

export async function waitFor(seconds: number): Promise<void> {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve();
    }, seconds * 1000);
  });
};

export function checkUrlForPath(...paths: string[]): boolean {
  return paths.some(path => window.location.href.includes(path));
};

export function validatePwd(str:string):boolean {
	let valid:boolean = false;

	if (str.length >= 8 && hasSpecialChar.test(str) && hasNumber.test(str) && hasUppercase.test(str) && hasLowerCase.test(str)) {
		valid = true;
	};

	return valid;
};

export function ms_to_days(ms:number) {
	return ms / (1000 * 60 * 60 * 24);
};

export function days_to_ms(days:number) {
	return days * (1000 * 60 * 60 * 24);
};

export function titleCase(str:string):string {
	if (str == null || str == undefined) return "";
  return str.toLowerCase().split(' ').map(function(word) {
    return (word.charAt(0).toUpperCase() + word.slice(1));
  }).join(' ');
}

export function titleCase_withStates(s:string):string{
	if (s == null || s == undefined || s.length == 0) return "";
	
	let result = s.toLowerCase();
	const states = ["al", "ak", "az", "ar", "ca", "co", "ct", "de", "fl", "ga", "hi", "id", "il", "in", "ia", "ks", "ky", "la", "me", "md", "ma", "mi", "mn", "ms", "mo", "mt", "ne", "nv", "nh", "nj", "nm", "ny", "nc", "nd", "oh", "ok", "or", "pa", "ri", "sc", "sd", "tn", "tx", "ut", "vt", "va", "wa", "wv", "wi", "wy"];
	const words = result.split(" ");
  result = "";
  for (const word of words) {
	if (word.length == 0) continue;

    if (states.indexOf(word.toLowerCase()) !== -1) {
      result += word.toUpperCase() + " ";
    } else {
      result += titleCase(word[0]) + word.slice(1) + " ";
    }
  }
  return result.trim();
};

export function meter_to_km(m:number):number {return m / 1000};
export function meter_to_mi(m:number):number {return (m/1000) * MI_PER_KM};
export function mi_to_meter(m:number):number {return (m/MI_PER_KM) * 1000}
export function sec_to_timeStr(s:number):string {
	let hrs:number = Math.floor(s / 3600);
	let mins:number = Math.floor((s - (hrs*3600)) / 60);
	return `${hrs}hr${mins}min`;
};
export function sec_to_timeStrCOLON(s:number):string {
	let hrs:number = Math.floor(s / 3600);
	let mins:number = Math.floor((s - (hrs*3600)) / 60);
	let mins_str:string;
	if(mins < 10){
		mins_str = "0" + mins.toString();
	} else {
		mins_str = mins.toString();
	}

	return `${hrs}:${mins_str}`;
};
export function min_to_timeStr(s:number):string {
	let hrs:number = Math.floor(s / 60);
	let mins:number = Math.floor((s - (hrs*60)));
	return `${hrs}:${mins}`;
};

//dependency of mergeSort
export function merge(left:Array<number>, right:Array<number>):Array<number> {
	let arr = []
	// Break out of loop if any one of the array gets empty
	while (left.length && right.length) {
			// Pick the smaller among the smallest element of left and right sub arrays
			if (left[0] < right[0]) {
					arr.push(left.shift())
			} else {
					arr.push(right.shift())
			}
	}

	// Concatenating the leftover elements
	// (in case we didn't go through the entire left or right array)
	return [ ...arr, ...left, ...right ]
};

//its mergeSort
export function mergeSort(array:Array<number>):Array<number> {
	const half = array.length / 2

	// Base case or terminating case
	if(array.length < 2){
		return array
	}

	const left = array.splice(0, half)
	return merge(mergeSort(left),mergeSort(array))
};

//converts degrees to radians
export function deg_to_rad(deg:number):number {return deg * Math.PI / 180;};

export function distance_latLong(A:{latitude:number,longitude:number},B:{latitude:number,longitude:number}):number|null {
	let dLat:number = deg_to_rad(B.latitude - A.latitude);
	let dLon:number = deg_to_rad(B.longitude - A.longitude);
	let a:number = Math.sin(dLat / 2) ** 2;
	a += Math.cos(deg_to_rad(A.latitude)) * Math.cos(deg_to_rad(B.latitude)) * (Math.sin(dLon / 2) ** 2);
	return 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 -a))
};

const EARTH_RADIUS_KM = 6371;

export function distance_latLong_toKM(A:{latitude:number,longitude:number},B:{latitude:number,longitude:number}):number|null {
	let dist:number|null = distance_latLong(A,B);
	if (dist !== null) dist *= EARTH_RADIUS_KM;
	return dist;
};

export function distance_latLong_toMi(A:{latitude:number,longitude:number},B:{latitude:number,longitude:number}):number|null {
	let dist:number|null = distance_latLong_toKM(A,B);
	if (dist !== null) dist *= MI_PER_KM;
	return dist;
};

/*
 * returns distance between input camps in geological coords
 * to convert to mi/km multiply output by earth radius in mi/km
 */

export function cg_dist(campA:Campground|{latitude:number,longitude:number}, campB:Campground) {
	let latA:number = deg_to_rad(campA.latitude);
	let lonA:number = deg_to_rad(campA.longitude);
	let latB:number = deg_to_rad(campB.latitude);
	let lonB:number = deg_to_rad(campB.longitude);
	let dLat:number = latB - latA;
	let dLon:number = lonB - lonA;
	let a:number = Math.pow(Math.sin(dLat/2), 2);
	a += Math.cos(latA) * Math.cos(latB) * Math.pow(Math.sin(dLon/2),2);
	return 2 * Math.atan2(Math.sqrt(a),Math.sqrt(1-a));
};

export function cg_dist_km(campA:Campground|{latitude:number,longitude:number}, campB:Campground) {
	let R:number = 6371; //radius of earth in km
	let c:number = cg_dist(campA,campB);
	return R * c;
};

export const remCampFromFolder = async (camp:number,folder:number) => {
	let success:boolean = false;
	let errMsg:string;

	await $.ajax({
		type: "post",
		url: "./userCampgroundFolder_remCamp",
		data: JSON.stringify({campID:camp,folderID:folder}),
		contentType: "application/json",
		dataType: "text",
		success: function(data) {
			if (data === "success") success = true;
			else {
				success = false;
				errMsg = data;
			}
		},
		error: (xhr, errStr, exc) => {
			success = false;
			errMsg = errStr;
		}
	});

	return new Promise<void>((resolve,reject) => {
		if (success) resolve();
		else reject(Error(errMsg));
	});
};

export const addCampToFolder = async (camp:number,folder:number) => {
	let success:boolean = false;
	let errMsg:string;

	await $.ajax({
		type: "post",
		url: "./userCampgroundFolder_addCamp",
		data: JSON.stringify({campID:camp,folderID:folder}),
		contentType: "application/json",
		dataType: "text",
		success: function(data) {
			if (data === "success") success = true;
			else {
				success = false;
				errMsg = data;
			}
		},
		error: (xhr, errStr, exc) => {
			success = false;
			errMsg = errStr;
		}
	});

	return new Promise<void>((resolve,reject) => {
		if (success) resolve();
		else reject(Error(errMsg));
	});
};

export const getCampsInFolder = async (folderID:number) => {
	let success:boolean = false;
	let response:string;
	let errMsg:string;

	await $.ajax({
		type: "get",
		url: `./getFolder?folderID=${folderID}`,
		dataType: "html",
		success: function(data) {
			response = data;
			success = true;
		},
		error: (xhr, errStr, exc) => {
			success = false;
			errMsg = errStr;
		}
	});

	return new Promise<string>((resolve,reject) => {
		if (success) resolve(response);
		else reject(Error(errMsg));
	});
};

export const createFolder = async (name:string) => {
	let success:boolean = false;
	let response:Folder;
	let errMsg:string;

	await $.ajax({
		type: "post",
		url: "./createFolder",
		data: JSON.stringify({folderName:name}),
		contentType: "application/json",
		dataType: "json",
		success: function(data) {
			response = data;
			success = true;
		},
		error: (xhr, errStr, exc) => {
			success = false;
			errMsg = errStr;
		}
	});

	return new Promise<Folder>((resolve,reject) => {
		if (success) resolve(response);
		else reject(Error(errMsg));
	})
};

export const deleteFolder = async (folderID:number) => {
	let success:boolean = false;
	let errMsg:string;

	await $.ajax({
		type: "post",
		url: "./deleteFolder",
		data: JSON.stringify({folderID:folderID}),
		contentType: "application/json",
		dataType: "text",
		success: function(data) {
			if (data == "success") success = true;
			else errMsg = data;
		},
		error: (xhr, errStr, exc) => {
			success = false;
			errMsg = errStr;
		}
	})

	return new Promise<void>((resolve,reject) => {
		if (success) resolve();
		else reject(Error(errMsg));
	});
};

export function parseDateStr(dateStr:string): Date {
	let date:Date;

	let dateStr_split:Array<string> = dateStr.split("-");
	if (dateStr_split.length != 3 || dateStr_split[0].length != 4 || dateStr_split[1].length != 2 || dateStr_split[2].length != 2) {
		return null;
	};
	let yr:number = parseInt(dateStr_split[0]);
	let mo:number = parseInt(dateStr_split[1]);
	let day:number = parseInt(dateStr_split[2]);

	if (mo < 1 || mo > 12 || day < 1 || day > 31) return null;

	date = new Date(yr,mo - 1,day);

	return date;
};

/* path should not include '/' */
export function setCookie(cname:string, cvalue:string, path:string, cookie_lifespan_days:number|null) {
	if (cookie_lifespan_days != null) {
		let expireDate:Date = new Date();
		expireDate.setDate(expireDate.getDate() + cookie_lifespan_days);

		document.cookie = cname + "=" + cvalue + ";expires=" + expireDate.toUTCString() + ";path=/" + path;
	} else {
		document.cookie = cname + "=" + cvalue  + ";path=/" + path;
	};
};

//same as setCookie but encodes in base65
export function setCookie_base64(cname:string, cvalue:string, path:string, cookie_lifespan_days:number) {
	let expireDate:Date = new Date();
	cvalue = cvalue
	.replace(/\u2013/g,'+')
	.replace(/-/g,'+')
	.replace(/_/g,'/')

	expireDate.setDate(expireDate.getDate() + cookie_lifespan_days);
	document.cookie = cname + "=" + btoa(unescape(encodeURIComponent(cvalue))) + ";expires=" + expireDate.toUTCString() + ";path=/" + path;
}


export function getCookie(cname:string):string {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

//same as getCookie but for cookies stored in base64
export function getCookie_base64(cname:string):string {
	let name = cname + "=";
	let decodedCookie = decodeURIComponent(document.cookie);
	let ca = decodedCookie.split(';');
	for(let i = 0; i <ca.length; i++) {
	  let c = ca[i];
	  while (c.charAt(0) == ' ') {
		c = c.substring(1);
	  }
	  if (c.indexOf(name) == 0) {
		return atob(c.substring(name.length, c.length)).replace(/\+/g,'-').replace(/\//g,'_');
	  }
	}
	return "";
};

/* path should not include '/' */
export function deleteCookie( name:string, path:string, domain:string ) {
  if( getCookie( name ) ) {
    /*document.cookie = name + "=" +
      ((path) ? ";path=/"+path:"")+
      ((domain)?";domain="+domain:"") +
      ";expires=Thu, 01 Jan 1970 00:00:01 GMT";

		return true;
		*/
		setCookie(name,'',path,-1);
		return true;
  } else {
		return false;
	}
};

export async function initLD():Promise<LDClient.LDClient> {
	const clientSideID = LD_CLIENT_KEY;
	let context;
	let loggedIn:string = getCookie("loggedIn");
	let uID:string|null = null;
	let ld_key = getCookie("ld_key");
	let anonymous:boolean = true;
	if (loggedIn !== null && loggedIn !== undefined && loggedIn.length) {
		anonymous = false;
	};

	context = {
		kind: 'user',
		key: ld_key,
		anonymous: anonymous
	}

	const ldclient = LDClient.initialize(clientSideID, context);

	ldclient.on("error", (e)=> {
		/* do nothing */
	});

	await ldclient.waitForInitialization();

	return ldclient;
};

export async function getFlagValue(
	key:string,
	ldClient:LDClient.LDClient | null,
	defaultValue:any = false
):Promise<LDClient.LDFlagValue> {
	let flagValue: LDClient.LDFlagValue;
	if (!ldClient) ldClient = await initLD();
	flagValue = await ldClient.variation(key, defaultValue);
	return flagValue;
};

export async function getFeatureFlags(flagKeys:Array<string>):Promise<Record<string,LDClient.LDFlagValue>> {
	let featureFlags:Record<string,LDClient.LDFlagValue> = {};

	let ldClient:LDClient.LDClient = await initLD()

	for (let i:number = 0; i < flagKeys.length; i++) {
		featureFlags[flagKeys[i]] = await getFlagValue(flagKeys[i], ldClient);
	};

	return featureFlags;
};

export function timeInMin_to_hrMinStr(minutes: number) {
	let hr: number = Math.floor(minutes / 60);
	let hr_str: string = hr < 10 ? "0" + hr.toString() : hr.toString();
	let min: number = minutes % 60;
	let min_str = min < 10 ? "0" + min.toString() : min.toString();
	return `${hr_str}:${min_str}`;
};


function constructShareLink(shareLink:string, ck:string, pk:string, nk:string, dk:string){
	let linkToShare:string = shareLink;
	if ($("#showCampgrounds").prop("checked")){
		linkToShare += "&ck=" + ck;
	}
	if ($("#showPOIs").prop("checked")){
		linkToShare += "&pk=" + pk;
	}
	if ($("#showDates").prop("checked")){
		linkToShare += "&dk=" + dk;
	}
	if ($("#showNotes").prop("checked")){
		linkToShare += "&nk=" + nk;
	}

	return linkToShare;

}

export function handleSharePopup(){

	const shareLink = $(this).attr("shareLink");
	$("#tripPrivacyModal").modal("show");

	let campsKey:string = $(this).attr("shareCampKey");
	let poisKey:string = $(this).attr("sharePOIKey");
	let notesKey:string = $(this).attr("shareNoteKey");
	let datesKey:string = $(this).attr("shareDateKey");



	$("#facebook").on("click", () => {
		let linkToShare:string = constructShareLink(shareLink, campsKey, poisKey, notesKey, datesKey);

		let link:string = "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(linkToShare);
		$("#tripPrivacyModal").modal("hide");
		window.open(link, '_blank');

	});

	$("#twitter").on("click", () => {
		let linkToShare:string = constructShareLink(shareLink, campsKey, poisKey, notesKey, datesKey);


		linkToShare = "Check out this awesome trip I made using @adventuregenie: " + linkToShare;
		linkToShare = "https://twitter.com/intent/tweet?text=" + encodeURIComponent(linkToShare);
		$("#tripPrivacyModal").modal("hide");
		window.open(linkToShare, '_blank');

	});

	$("#copyLink").on("click", () => {
		let linkToShare:string = constructShareLink(shareLink, campsKey, poisKey, notesKey, datesKey);

		navigator.clipboard.writeText(linkToShare).then(function() {
			$("#copyIcon").removeClass("ai-link")
			$("#copyIcon").parent().addClass("border-success")
			$("#copyIcon").addClass("ai-check text-success")
			setTimeout(() =>{
				$("#copyIcon").removeClass("ai-check text-success")
				$("#copyIcon").parent().removeClass("border-success")
				$("#copyIcon").addClass("ai-link")
			},2000)
		}).catch(function(error) {
			console.error('Error copying text: ', error);
		});


		//TODO : GIVE USER FEEDBACK THAT IT HAS BEEN COPIED
		//$("#submitShareSettings").html("Copied to Clipboard");
	});
}


//Returns ["limit", popupAttr] for a given list of freemiumAccess keys
export async function getLimit(freemiumAccessKeys:string[]){

	if (window.featureFlags == undefined || window.featureFlags.freemiumAccess == undefined) {
		await getAllFeatureFlags();
	};

	if (window.featureFlags.freemiumAccess == false || window.featureFlags.freemiumAccess.off == true) {
		return ["inf", null];
	}

	let subLevel: number;
	let subLevelString:string;
	let popupAttr: string|null = null;

	subLevelString = getSubLevelString();
	subLevel = getSubLevelInt();

	freemiumAccessKeys.push(subLevelString);

	let tier_info:any = window.featureFlags.freemiumAccess;
	for(let i:number = 0; i < freemiumAccessKeys.length; i++){
		tier_info = tier_info[freemiumAccessKeys[i]];
	}
	if (typeof(tier_info) != "number"){
		return ["inf", null];
	}


	if (subLevel > -1) {
		if(window.featureFlags.freeTrialState == "carded"){
			popupAttr = 'freemiumShowCardedTrial';
		}else{
			popupAttr = 'freemiumShowSubscribe';
		}
	} else {


		popupAttr = 'freemiumShowSignup';
	}

	return [tier_info, popupAttr];

}

export async function getAccess(token:string){

	//Grab sublevel of user and access level to see if the should be able to to do action

	if (window.featureFlags == undefined || window.featureFlags.freemiumAccess == undefined) {
		await getAllFeatureFlags();
	};

	let subLevel: number = getSubLevelInt();
	let cacheBool:boolean;
	if (window.featureFlags.freemiumAccess == false || window.featureFlags.freemiumAccess.off == true) {
		cacheBool = false;
	}else{
		let accessLevel:number = parseInt(window.featureFlags.freemiumAccess[token])
		if (subLevel + 1 >= accessLevel){
			cacheBool = true;
		}else{
			cacheBool = false
		}
	}
	return cacheBool

}


export async function getAllFeatureFlags(){
	window.featureFlags = await getFeatureFlags(featureFlagKeys);
}

export function getSubLevelString(){
	let subLevelString:string;
	if (window.GAsubLevel == undefined) {
		subLevelString = "anonymous";
	} else {
		if(parseInt(window.GAsubLevel) == 0){
			subLevelString = "member";
		}else{
			subLevelString = "subscriber";
		}
	}

	return subLevelString
}

export function getSubLevelInt(){
	let subLevel: number;
	if (window.GAsubLevel == undefined) {
		subLevel = -1;
	} else {
		subLevel = parseInt(window.GAsubLevel);
	}
	return subLevel
}

export function levenshteinDistance(a:string, b:string) {
	if (a.length == 0) return b.length;
	if (b.length == 0) return a.length;

	const matrix = [];

	for (let i = 0; i <= b.length; i++) {
		matrix[i] = [i];
	}

	for (let j = 0; j <= a.length; j++) {
		matrix[0][j] = j;
	}

	for (let i = 1; i <= b.length; i++) {
		for (let j = 1; j <= a.length; j++) {
			if (b.charAt(i - 1) == a.charAt(j - 1)) {
				matrix[i][j] = matrix[i - 1][j - 1];
			} else {
				matrix[i][j] = Math.min(
					matrix[i - 1][j - 1] + 1,
					Math.min(matrix[i][j - 1] + 1, matrix[i - 1][j] + 1)
				);
			}
		}
	}

	return matrix[b.length][a.length];
};